/**
 * VenueChip — tiny K (blue) / P (purple) / US (emerald) badge for
 * venue-tagging rows in unified tables (Open Orders, Open Positions,
 * MyTrades). Same dimensions as the existing YES/NO side chips so columns
 * stay aligned.
 */

export type VenueTag = 'kalshi' | 'polymarket' | 'polymarket_us';

interface VenueChipProps {
  venue: VenueTag;
}

export function VenueChip({ venue }: VenueChipProps) {
  if (venue === 'kalshi') {
    return (
      <span
        className="bg-blue-500/20 text-blue-400 rounded px-1.5 py-0.5 text-[10px] font-bold"
        title="Kalshi"
      >
        K
      </span>
    );
  }
  if (venue === 'polymarket_us') {
    return (
      <span
        className="bg-emerald-500/20 text-emerald-400 rounded px-1.5 py-0.5 text-[10px] font-bold"
        title="Polymarket US"
      >
        US
      </span>
    );
  }
  return (
    <span
      className="bg-purple-500/20 text-purple-400 rounded px-1.5 py-0.5 text-[10px] font-bold"
      title="Polymarket"
    >
      P
    </span>
  );
}
